<template>
  <section class="section section-shaped  section-lg my-0">

    <!--        <div class="shape shape-style-1 bg-gradient-default">-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--            <span></span>-->
    <!--        </div>-->


    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">


            <div class="text-center">
              <img class="w-100 " style="max-width: 183px" :src="$baseUrl + 'img/brand/logo-1.png'">
            </div>
            <div class="mt-3"/>

            <template>
              <div class="text-center text-muted mb-4">
                <small class="text-main-color">客戶訂購系統</small>
              </div>
              <div class="mt-5"/>
              <form role="form">

                <base-input
                    class="mb-3"
                    placeholder="帳號"
                    addon-left-icon="fa fa-user"
                    :value="account"
                    @input="value => account = value"
                />
                <base-input
                    :type="showPassword ? 'text' : 'password'"
                    placeholder="密碼"
                    addon-left-icon="fa fa-lock"
                    :value="password"
                    @input="value => password = value"
                >
                  <template slot="addonRight">
                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                       style="cursor:pointer"
                       @click="showPassword = !showPassword"></i>
                  </template>
                </base-input>
                <div class="text-center">
                  <base-button class="w-100 my-4 font-size-16" style="max-width: 108px" size="lg" type="main-color"
                               v-text="'登入'" @click="clickLogin"/>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/forgot-password" class="text-light">
                <small>忘記密碼?</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import {IS_DEBUG} from '@/util/globals';
import {md5} from '@/util/encryption';
import {checkError} from '@/util/error_handler';
import {dispatch} from "vuex-pathify";

export default {
  data() {
    return {
      account: '',
      password: '',
      showPassword: false,
    };
  },
  async beforeCreate() {
    this.$store.dispatch('initSalt');
    this.$store.dispatch('showLoading');
    if (IS_DEBUG) {
      this.account = 'ethanjhou@gmail.com';
      this.password = 'qwer1234';
    }
  },
  methods: {
    async clickLogin() {
      if (!this.account || !this.password) {
        this.$store.dispatch('error/show', {msg: !this.account ? '請輸入帳號' : '請輸入密碼'});
        return;
      }

      this.$store.dispatch('showLoading');

      try {
        const text = JSON.stringify({
          'password': md5(this.password),
        });
        const data = await this.$store.dispatch('sign_in_with_email', {
          email: this.account,
          password: text,
          // token,
        });
        // console.log(data);
        this.$store.dispatch('updateSalt');
        this.$store.dispatch('hideLoading');

        if (checkError(this.$dialog, data)) {
          let r = await this.$store.dispatch('getPermissions', {needLogin: false});
          r = r && await this.$store.dispatch('initMyOrganization', {needLogin: false});
          if (r) {
            // 標記這次是「剛登入」，首頁進去後負責跳登入公告（見 Home.vue）
            this.$store.commit('setJustLoggedIn', true);
            // 多門市帳號且沒有可沿用的上次門市時，先到選擇頁
            const org = this.$store.state.myOrganization;
            this.$router.push(org && org.id ? '/' : {name: 'select-organization'});
          }
        } else {
          this.$store.dispatch('clear');
        }
      } catch (e) {
        console.error(e);
        this.$store.dispatch('hideLoading');
        const errorText = (e && e.response && e.response.data && e.response.data.error && e.response.data.error.text) || '登入失敗，請稍後再試';
        this.$dialog.error({
          text: errorText,
          title: '錯誤',
        })
      }
    },
  },
};
</script>
<style>
</style>
